import React, { useEffect, useRef, useState } from "react";
import { Upload, X } from "lucide-react";

export const MAX_UPDATE_PHOTO_BYTES = 10 * 1024 * 1024;
export function validateUpdatePhotos(files) {
  if (files.some((file) => !["image/jpeg", "image/png", "image/webp"].includes(file.type))) return "Choose JPG, PNG or WEBP photos only.";
  if (files.some((file) => file.size > MAX_UPDATE_PHOTO_BYTES)) return "Each photo must be 10 MB or smaller.";
  if (files.some((file) => file.size === 0)) return "Empty image files cannot be attached.";
  return "";
}

export default function UpdatePhotos({ files, onChange, disabled, onError }) {
  const input = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [previews, setPreviews] = useState([]);
  useEffect(() => {
    const next = files.map((file) => ({ file, url: URL.createObjectURL(file) }));
    setPreviews(next);
    return () => next.forEach(({ url }) => URL.revokeObjectURL(url));
  }, [files]);
  const add = (selection) => {
    if (disabled) return;
    const chosen = Array.from(selection);
    const error = validateUpdatePhotos(chosen);
    if (error) { onError(error); return; }
    const next = [...files];
    chosen.forEach((file) => {
      if (!next.some((item) => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified)) next.push(file);
    });
    onChange(next);
    onError("");
  };
  return <section className="update-photos" aria-labelledby="update-photos-heading">
    <h3 id="update-photos-heading">Update Photos <small>(optional)</small></h3>
    <p>Upload photos showing the progress for this update.</p>
    <div className={"detail-upload-area " + (dragging ? "is-dragging" : "")} onDragOver={(event) => { event.preventDefault(); if (!disabled) setDragging(true); }} onDragLeave={() => setDragging(false)} onDrop={(event) => { event.preventDefault(); setDragging(false); add(event.dataTransfer.files); }}>
      <Upload size={28} aria-hidden="true" /><strong>Drag &amp; drop photos here</strong><span>or</span>
      <button className="detail-button" type="button" disabled={disabled} onClick={() => input.current.click()}>Browse Files</button>
      <span>JPG, PNG or WEBP · Max 10MB each</span>
      <input ref={input} type="file" multiple hidden disabled={disabled} accept="image/jpeg,image/png,image/webp" aria-label="Update photos" onChange={(event) => { add(event.target.files); event.target.value = ""; }} />
    </div>
    {files.length > 0 && <><h3>Selected Photos ({files.length})</h3><div className="update-photo-previews">{previews.map(({ file, url }, index) => <figure key={url}><img src={url} alt={file.name} /><figcaption title={file.name}>{file.name}</figcaption><button type="button" disabled={disabled} aria-label={"Remove " + file.name} onClick={() => { onChange(files.filter((_, i) => i !== index)); onError(""); }}><X size={16} /></button></figure>)}</div></>}
  </section>;
}
